// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import RoleIcon from 'components/ui/icons/Role'
import LinkRoleIcon from 'components/ui/icons/LinkRole'
import SectionItem from 'components/SideBar/ui/SectionItem'
import type {
  AssignmentItem_assignment as Assignment,
} from './__generated__/AssignmentItem_assignment.graphql'

type Props = $ReadOnly<{
  assignment: Assignment,
}>

const roleIcon = () => <RoleIcon />
const linkRoleIcon = () => <LinkRoleIcon />

function AssignmentItem({assignment}: Props): Node {
  if (assignment.role.isFocus)
    return null

  return (
    <SectionItem
      title={assignment.localizedName}
      renderIcon={assignment.role.isLinked ? linkRoleIcon : roleIcon}
      href={assignment.chartPath}
    />
  )
}

export default (createFragmentContainer(AssignmentItem, {
  assignment: graphql`
    fragment AssignmentItem_assignment on Assignment {
      localizedName
      chartPath

      role {
        isFocus
        isLinked
      }
    }
  `,
}): RelayFragmentContainer<typeof(AssignmentItem)>)
